import { render, staticRenderFns } from "./JLggzTable.vue?vue&type=template&id=6b3d5033&scoped=true"
import script from "./JLggzTable.vue?vue&type=script&lang=js"
export * from "./JLggzTable.vue?vue&type=script&lang=js"
import style0 from "./JLggzTable.vue?vue&type=style&index=0&id=6b3d5033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d5033",
  null
  
)

export default component.exports